import { MULTIPAGE_TESTING_GUIDE_STEPS_AMOUNT } from '../constants';
import { create } from 'zustand';

interface MultipageTestingGuideStoreState {
  currentStep: number | null;
}

interface MultipageTestingGuideStoreActions {
  setCurrentStep: (step: number) => void;
  nextStep: () => void;
  previousStep: () => void;
}

export const useMultipageTestingGuideStore = create<
  MultipageTestingGuideStoreState & MultipageTestingGuideStoreActions
>()((set) => ({
  currentStep: null,

  setCurrentStep: (step: number) => set(() => ({ currentStep: step })),
  nextStep: () =>
    set(({ currentStep }) => ({
      currentStep:
        currentStep === null ? 1 : Math.min(currentStep + 1, MULTIPAGE_TESTING_GUIDE_STEPS_AMOUNT),
    })),
  previousStep: () =>
    set(({ currentStep }) => ({
      currentStep: currentStep === null ? null : Math.max(currentStep - 1, 0),
    })),
}));
